import { render, staticRenderFns } from "./TriangleIcon.vue?vue&type=template&id=ef54ada6&scoped=true&"
var script = {}
import style0 from "./TriangleIcon.vue?vue&type=style&index=0&id=ef54ada6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54ada6",
  null
  
)

export default component.exports